var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.232 16l-9.116 9.116 1.768 1.768L16 17.768l9.116 9.116 1.768-1.768L17.768 16l9.116-9.116-1.768-1.768L16 14.232 6.884 5.116 5.116 6.884 14.232 16z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMjMyMiAxNkw1LjExNjIxIDI1LjExNkw2Ljg4NDIxIDI2Ljg4NEwxNi4wMDAyIDE3Ljc2OEwyNS4xMTYyIDI2Ljg4NEwyNi44ODQyIDI1LjExNkwxNy43NjgyIDE2TDI2Ljg4NDIgNi44ODQwM0wyNS4xMTYyIDUuMTE2MDNMMTYuMDAwMiAxNC4yMzJMNi44ODQyMSA1LjExNjAzTDUuMTE2MjEgNi44ODQwM0wxNC4yMzIyIDE2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCloseIcon as ReactComponent };